<template>
  <div class="content">
    <div class="md-layout">
      <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100">
        <md-card>
          <md-card-header data-background-color="red">
            <h4 class="title">Donor List</h4>
            <p class="category">List of all the donors</p>
          </md-card-header>
          <md-card-content>
            <donor-table table-header-color="green"></donor-table>
          </md-card-content>
        </md-card>
      </div>

    </div>
  </div>
</template>

<script>
  import DonorTable from '@/components/Tables/DonorTable.vue'

  export default{
    components: {
      DonorTable
    }
  }
</script>
